import * as React from 'react';
import { Spinner } from 'office-ui-fabric-react';

import PrimaryButton from 'views/components/UI/Buttons/PrimaryButton';
import { cancel } from 'utils/request';

interface IProps {
  message?: string;
}

const CustomSpinner: React.FC<IProps> = (props: IProps) => {
  return (
    <>
      <Spinner
        styles={{
          root: {
            position: 'fixed',
            zIndex: 402,
            width: '100vw',
            height: '100vh',
            background: '#000000',
            opacity: '0.5',
            top: 0,
            left: 0
          },
          circle: {
            width: 200,
            height: 200,
            borderWidth: 7.5,
          },
        }}
        size={3}
      />
    </>
  );
};

export default CustomSpinner;
